var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('ld-persistent-banner',{staticClass:"text-pre",attrs:{"link":_vm.redirectUrl,"warningIcon":true,"error":true,"text":_vm.text,"buttonText":_vm.buttonText,"complete":_vm.isComplete}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }